// import React from "react";
// import BeeHive from "./assets/BeeHive.png";
// import Beekeeping from "./assets/Beekeeping.png";
// import TSTransco from "./assets/TSTransco.png";
// import QueenBee from "./assets/QueenBee.png";
// import Brood from "./assets/Brood.png";

// const AboutUs = () => {
//   return (
//     <div className="font-poppins mt-27 text-[#333]  bg-fixed flex flex-col items-center min-h-screen overflow-y-auto">
//       {/* First Section */}
//       <div className="w-full flex justify-center items-center mt-5">
//         <div className="w-[80%] max-w-[2000px] bg-[rgba(254,232,217,0.5)] rounded-lg p-5 shadow-md transition-transform transition-shadow duration-300 ease-in-out ml-[50px] mr-[50px] hover:shadow-lg hover:scale-[1.02]">
//           <div className="about-us-content">
//             <h1 className="text-center text-4xl font-bold [-webkit-text-stroke:1px_#5a3e12] text-shadow-[3px_3px_6px_rgba(255,255,255,0.5)]">
//               <b>THE GREAT HONEY CO. (TGHC)</b>
//             </h1>

//             <div className="flex justify-between items-center bg-gradient-to-r from-[#edd2d1] to-[#c0a67b] p-3 rounded-lg shadow-md mt-5 transition-transform duration-300 ease-in-out hover:translate-y-[-5px]">
//               <div className="w-[60%]">
//                 <h2 className="text-2xl font-bold">OUR VISION</h2>
//                 <p className="text-base">
//                   To revolutionize sustainable honey production while empowering farmers and fostering a thriving ecosystem through beekeeping. Our goal is to create a thriving, self-sustaining network of responsible beekeepers. Through innovation, we strive to ensure the highest quality honey production. Ultimately, we seek to make beekeeping a driving force for environmental and economic growth.
//                 </p>
//               </div>
//               <div className="w-[200px] h-[250px] object-cover rounded-lg transition-transform duration-300 ease-in-out">
//                 <img src={BeeHive} alt="Beehive" className="w-full h-full object-cover rounded-lg hover:scale-[1.05]" />
//               </div>
//             </div>

//             <div className="flex justify-between items-center bg-gradient-to-l from-[#edd2d1] to-[#c0a67b] p-3 rounded-lg shadow-md mt-5 transition-transform duration-300 ease-in-out hover:translate-y-[-5px]">
//               <div className="w-[200px] h-[250px] object-cover rounded-lg transition-transform duration-300 ease-in-out">
//                 <img src={Beekeeping} alt="Beekeeping" className="w-full h-full object-cover rounded-lg hover:scale-[1.05]" />
//               </div>
//               <div className="w-[60%]">
//                 <h2 className="text-2xl font-bold">OUR MISSION</h2>
//                 <p className="text-base">
//                   At TGHC, our mission is to enhance agricultural productivity by promoting beekeeping, ensuring high-quality honey production, and supporting farmers with innovative techniques and sustainable practices. Our mission is to educate and support farmers in adopting beekeeping for agricultural improvement. We are committed to producing pure, high-quality honey using ethical and eco-friendly practices. By fostering awareness of the importance of bees, we aim to strengthen global sustainability efforts.
//                 </p>
//               </div>
//             </div>

//             <div className="mt-5">
//               <h2 className="text-2xl font-bold">HOW WE STARTED?</h2>
//               <p className="text-base">
//                 It would be just another ordinary day in SIBM Pune if I hadn’t met my friend, who made me understand the situation of farmers who toil a lot but still, the yield depends on several factors. We met several farmers and heard about their problems. We were astonished to hear about the factors affecting the yield and the methods farmers follow in agriculture.
//               </p>
//               <p className="text-base">
//                 We analyzed the reasons for the shortage of resources and also researched ways to improve the yield. We found out that a small bee can help many farmers improve the quality and quantity of their products. The bees help in cross-pollination by which the reproduction in plants will happen at a better rate. This research has paved the way for me to start the first step in establishing the company.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Our Team Section */}
//       <div className="p-10 text-center bg-[rgba(218,214,190,0.5)] w-full mt-10 text-[#000000]">
//         <h2 className="text-3xl text-[#804b0b] mb-2.5 font-bold">
//           <b>OUR TEAM OF EXPERTS</b>
//         </h2>
//         <p className="text-sm mb-7.5">
//           Meet our passionate team of honey production professionals
//         </p>
//         <div className="flex gap-5 justify-center flex-wrap">
//           <div>
//             <img src={Brood} alt="Best Brood" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
//             <p className="text-xl pt-5 font-bold">BEST BROOD AVAILABLE</p>
//           </div>
//           <div>
//             <img src={QueenBee} alt="Shipping Queen Bee" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
//             <p className="text-xl pt-5 font-bold">SHIPPING QUEEN BEE</p>
//           </div>
//           <div>
//             <img src={TSTransco} alt="Working with TSTRANSCO" className="w-[250px] h-[250px] rounded-lg object-cover shadow-md transition-transform duration-300 ease-in-out hover:scale-[1.05]" />
//             <p className="text-xl pt-5 font-bold">WORKING WITH TSTRANSCO</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;


import React, { useEffect } from "react";
import { 
  Leaf, 
  Target, 
  Users, 
  History, 
  ArrowRight, 
  ShieldCheck, 
  Sprout 
} from "lucide-react";

// Assuming these are your local imports
import BeeHive from "./assets/BeeHive.png";
import Beekeeping from "./assets/Beekeeping.png";
import TSTransco from "./assets/TSTransco.png";
import QueenBee from "./assets/QueenBee.png";
import Brood from "./assets/Brood.png";
import BeeScrollProgress from "../Home_Page/components/BeeScrollProgress";

const AboutUs = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Use "instant" if you don't want the sliding effect
    });
  }, []);
  return (
    <div className="bg-[#f7f3f0] mt-20 font-poppins text-[#333] min-h-screen">
      <BeeScrollProgress/>

      {/* --- HERO SECTION --- */}
      <header className="relative py-20 bg-gradient-to-b from-[#f57c00] to-[#d3a863] text-white text-center px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4 tracking-tight drop-shadow-md">
            THE GREAT HONEY CO.
          </h1>
          <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto">
            Revolutionizing sustainable honey production and empowering rural agricultural ecosystems.
          </p>
        </div>
      </header>

      {/* --- VISION & MISSION (Responsive Grid) --- */}
      <section className="max-w-7xl mx-auto px-6 mt-5 mb-5">
        <div className="grid md:grid-cols-2 gap-8">
          
          {/* Vision Card */}
          <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all border-t-4 border-[#f57c00] group">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-3 bg-orange-100 rounded-lg text-[#f57c00]">
                <Target size={32} />
              </div>
              <h2 className="text-2xl font-bold text-[#f57c00]">OUR VISION</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              To revolutionize sustainable honey production while empowering farmers and fostering a thriving ecosystem through beekeeping. We strive to ensure the highest quality production and make beekeeping a driving force for environmental growth.
            </p>
            <img 
              src={BeeHive} 
              alt="Beehive" 
              className="mt-6 rounded-xl w-full h-48 object-cover group-hover:scale-[1.02] transition-transform" 
            />
          </div>

          {/* Mission Card */}
          <div className="bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all border-t-4 border-[#d3a863] group">
            <div className="flex items-center gap-4 mb-6">
              <div className="p-3 bg-amber-100 rounded-lg text-[#d3a863]">
                <ShieldCheck size={32} />
              </div>
              <h2 className="text-2xl font-bold text-[#d3a863]">OUR MISSION</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              At TGHC, our mission is to enhance agricultural productivity by promoting beekeeping, ensuring high-quality honey production, and supporting farmers with innovative techniques and sustainable practices.
            </p>
            <img 
              src={Beekeeping} 
              alt="Beekeeping" 
              className="mt-6 rounded-xl w-full h-48 object-cover group-hover:scale-[1.02] transition-transform" 
            />
          </div>

        </div>
      </section>

      {/* --- STORY SECTION --- */}
      <section className="bg-white py-16 px-6">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="flex items-center gap-2 text-[#f57c00] mb-4">
              <History size={20} />
              <span className="font-bold tracking-widest uppercase text-sm">Our Journey</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#333]">How We Started?</h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                It would be just another ordinary day in SIBM Pune if I hadn’t met my friend, who made me understand the situation of farmers who toil a lot but still, the yield depends on several factors.
              </p>
              <p>
                We found out that a small bee can help many farmers improve the quality and quantity of their products. This research has paved the way for establishing TGHC.
              </p>
            </div>
            <button className="mt-8 flex items-center gap-2 bg-[#f57c00] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#e67300] transition-colors shadow-lg">
              Learn More <ArrowRight size={18} />
            </button>
          </div>
          <div className="relative">
             <div className="absolute inset-0 bg-[#d3a863] rounded-3xl rotate-3 -z-10 opacity-20"></div>
             <img 
               src={Brood} 
               alt="Beekeeping Story" 
               className="rounded-3xl shadow-2xl w-full h-auto object-cover"
             />
          </div>
        </div>
      </section>

      {/* --- TEAM / EXPERTISE SECTION --- */}
      <section className="py-20 px-6 bg-[#f7f3f0]">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex justify-center mb-4">
            <Users className="text-[#f57c00]" size={40} />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#804b0b]">OUR TEAM OF EXPERTS</h2>
          <p className="text-gray-500 mb-12 max-w-xl mx-auto">
            Meet our passionate team of honey production professionals and technical partners.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Expert 1 */}
            <div className="bg-white p-4 rounded-2xl shadow-md hover:shadow-xl transition-shadow group">
              <div className="overflow-hidden rounded-xl mb-4">
                <img src={Brood} alt="Brood" className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
              </div>
              <h3 className="text-xl font-bold text-[#333]">BEST BROOD AVAILABLE</h3>
              <p className="text-[#f57c00] font-medium text-sm mt-1">Quality Assurance</p>
            </div>

            {/* Expert 2 */}
            <div className="bg-white p-4 rounded-2xl shadow-md hover:shadow-xl transition-shadow group">
              <div className="overflow-hidden rounded-xl mb-4">
                <img src={QueenBee} alt="Queen Bee" className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
              </div>
              <h3 className="text-xl font-bold text-[#333]">SHIPPING QUEEN BEE</h3>
              <p className="text-[#f57c00] font-medium text-sm mt-1">Logistics & Supply</p>
            </div>

            {/* Expert 3 */}
            <div className="bg-white p-4 rounded-2xl shadow-md hover:shadow-xl transition-shadow group">
              <div className="overflow-hidden rounded-xl mb-4">
                <img src={TSTransco} alt="TSTransco" className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
              </div>
              <h3 className="text-xl font-bold text-[#333]">TSTRANSCO COLLABORATION</h3>
              <p className="text-[#f57c00] font-medium text-sm mt-1">Technical Partner</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- FOOTER CTA --- */}
      <footer className="bg-[#333] py-12 text-center text-white">
        <div className="flex justify-center gap-4 mb-6">
          <Leaf className="text-[#d3a863]" />
          <Sprout className="text-[#f57c00]" />
        </div>
        <p className="opacity-70 text-sm italic">
          "A small bee can help many farmers improve the quality of their life."
        </p>
        {/* <p className="mt-4 font-semibold">© 2025 THE GREAT HONEY CO.</p> */}
      </footer>
    </div>
  );
};

export default AboutUs;